<template>
  <div class="modal" v-show="show">
    <div class="content">
      <div class="header">
        <div class="modal-title">
          填写车主手机号
        </div>
      </div>
      <div class="center">
        <div class="form-area">
          <div class="item">
            <span>手机号</span>
            <input v-model="mobile" style="border:none;margin-left:20px;padding-bottom:10px;">
          </div>
          <!-- <div class="item">
            <span>验证码</span>
            <input v-model="code" style="border:none;margin-left:20px;padding-bottom:10px;">
          </div> -->
        </div>
      </div>
      <div class="footer">
        <button class="footer-btn" @click="handleSubmit">确定</button>
      </div>
    </div>
    <!-- <div>
      <i class="el-icon-circle-close" style="font-size:2rem;color:#fff;margin-top:2rem"></i>
    </div> -->
  </div>
  
</template>

<script>
export default {
  props:{
    show: {
      required: true,
      type: Boolean
    },
  },
  data(){
    return {
      mobile:'',
      code:''
    }
  },
  methods:{
    handleSubmit(){
      if((/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile))){ 
        localStorage.setItem('mobileAndTime',this.mobile+'&'+(new Date().getTime() + 1000*3600*24*7))
        this.$emit('closeModal',this.mobile)
      }else{
        return this.$toast.fail('请输入正确的手机号');
      }
    }
  }
}
</script>
<style scoped lang="scss">
  @import './modal.scss';
</style>
